module.exports = __webpack_public_path__ + "l.no1.f5258a9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/l.no1.jpg
// module id = 2o9h
// module chunks = 0